import { SET_HOMEPAGE_ARTICLES, SET_NEWS_AOL } from './types'
import { AppDispatch, RootState } from 'redux/store'
import { CAArticle } from '../../interfaces/ca'

export const setHomepageArticles = (homepageArticles: CAArticle[]) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    if (getState().ca.homepageArticles !== homepageArticles) {
      dispatch({
        type: SET_HOMEPAGE_ARTICLES,
        homepageArticles
      })
    }
  }
}

export const setNewsAol = (newsAol: string) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    if (getState().ca.newsAol !== newsAol) {
      dispatch({
        type: SET_NEWS_AOL,
        newsAol
      })
    }
  }
}
